import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import collapseIcon from "assets/svgs/collapse.svg";
import invisibleIcon from "assets/svgs/invisible.svg";
import unCollapseIcon from "assets/svgs/uncollpase.svg";

import clsx from "clsx";
import React from "react";
import { menuItemStyles } from ".";
import { GroupAction } from "../../../../types";
import { TicketGroup } from "../../../Tickets/types";

interface Props {
  group: TicketGroup;
  handleClick: (val: GroupAction) => void;
}

export default function ListGroupMenuItems({ group, handleClick }: Props) {
  const options = [
    {
      icon: group.isCollapse ? unCollapseIcon : collapseIcon,
      label: group.isCollapse ? "Expand group" : "Collapse group",
      type: group.isCollapse ? GroupAction.UN_COLLAPSE : GroupAction.COLLAPSE,
    },
    {
      icon: invisibleIcon,
      label: "Hide group",
      type: GroupAction.HIDE,
    },
  ];

  return options.map(({ icon, label, type }) => (
    <DropdownMenu.Item
      key={label}
      onClick={() => handleClick(type)}
      className={clsx("", menuItemStyles)}
    >
      <img src={icon} alt={label} className="size-5" />
      {label}
    </DropdownMenu.Item>
  ));
}
